import { render, staticRenderFns } from "./social-buttons.vue?vue&type=template&id=7b41fa22"
import script from "./social-buttons.vue?vue&type=script&lang=js"
export * from "./social-buttons.vue?vue&type=script&lang=js"
import style0 from "./social-buttons.vue?vue&type=style&index=0&id=7b41fa22&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports